import { render, staticRenderFns } from "./mentionable.vue?vue&type=template&id=2b9e37e6&scoped=true&"
import script from "./mentionable.vue?vue&type=script&lang=js&"
export * from "./mentionable.vue?vue&type=script&lang=js&"
import style0 from "./mentionable.vue?vue&type=style&index=0&id=2b9e37e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e37e6",
  null
  
)

export default component.exports